import { InlineMath, BlockMath } from "react-katex";
import GraphViewer from "../../../../components/GraphPlotter/GraphViewer";
import SelectInput from "../../../../components/inputs/SelectInput";

// Losowanie a i b z przedzialu [-3, 3], z wykluczeniem zera
function losujLiczbyZ0() {
  const losuj = () => Math.floor(Math.random() * 7) - 3; // zakres [-3, 3], w tym 0
  return { a: losuj(), b: losuj() };
}

export function generateTask() {
  const { a, b } = losujLiczbyZ0();

  const encode = (v) => (v < 0 ? "< 0" : v === 0 ? "= 0" : "> 0");

  return {
    type: "SignOfLineTask",
    data: {
      a,
      b,
      correctAnswer: {
        a: encode(a),
        b: encode(b),
      },
    },
  };
}

export function renderTask({ data }) {
  const { a, b } = data;
  return (
    <div className="space-y-2">
      <p>
        Na wykresie przedstawiono prosta <InlineMath math="y = ax + b" />.
      </p>
      <div style={{ maxWidth: 360 }}>
        <GraphViewer
          width={360}
          equations={[`y = ${a}*x + (${b})`]}
          points={{}}
          segments={[]}
          xRange={[-6, 6]}
          yRange={[-6, 6]}
        />
      </div>
      <p>
        Okresl znak wspolczynnika <InlineMath math="a" /> oraz wyrazu wolnego{" "}
        <InlineMath math="b" />.
      </p>
    </div>
  );
}

export function renderInput(task, userInput, setUserInput) {
  return (
    <div className="mt-4">
      <div style={{ maxWidth: "350px", marginBottom: "1rem" }}>
        <label className="flex items-center gap-2">
          <InlineMath math="a\text{:}" />
          <SelectInput
            value={userInput?.a || ""}
            onChange={(e) =>
              setUserInput({ ...userInput, a: e.target.value })
            }
            options={[
              { value: "< 0", label: "< 0" },
              { value: "= 0", label: "= 0" },
              { value: "> 0", label: "> 0" },
            ]}
          />
        </label>
      </div>

      <div style={{ maxWidth: "350px" }}>
        <label className="flex items-center gap-2">
          <InlineMath math="b\text{:}" />
          <SelectInput
            value={userInput?.b || ""}
            onChange={(e) =>
              setUserInput({ ...userInput, b: e.target.value })
            }
            options={[
              { value: "< 0", label: "< 0" },
              { value: "= 0", label: "= 0" },
              { value: "> 0", label: "> 0" },
            ]}
          />
        </label>
      </div>
    </div>
  );
}

export function checkAnswer(task, userInput) {
  const { a, b } = task.data;

  const encode = (v) => (v < 0 ? "< 0" : v === 0 ? "= 0" : "> 0");

  const expected = {
    a: encode(a),
    b: encode(b),
  };

  const signMap = {
    "< 0": -1,
    "= 0": 0,
    "> 0": 1,
  };

  const isCorrect =
    signMap[userInput.a] === signMap[expected.a] &&
    signMap[userInput.b] === signMap[expected.b];

  return {
    isCorrect,
    expected,
    actual: userInput,
    comment: null,
  };
}

export function renderAnswer({ data }) {
  const sign = (v) => (v < 0 ? "< 0" : v === 0 ? "= 0" : "> 0");

  return (
    <div style={{ marginTop: "0.5rem" }}>
      <div style={{ display: "flex", gap: "1.5rem", marginBottom: "1rem" }}>
        <InlineMath math={`a ${sign(data.a)}`} />
        <InlineMath math={`b ${sign(data.b)}`} />
      </div>
    </div>
  );
}

export function renderExplanation({ data }) {
  const sign = (v) => (v > 0 ? "> 0" : v < 0 ? "< 0" : "= 0");

  return (
    <div className="space-y-2">
      <p>
        Na podstawie wykresu odczytujemy kierunek nachylenia prostej oraz punkt
        przeciecia z osia <InlineMath math="Oy" />.
      </p>
      <ul className="list-disc list-inside">
        <li>
          Jesli wykres rosnie, to <InlineMath math="a > 0" />; jesli maleje, to{" "}
          <InlineMath math="a < 0" />; jesli jest poziomy, to{" "}
          <InlineMath math="a = 0" />.
        </li>
        <li>
          Jesli przecina os <InlineMath math="Oy" /> powyzej zera, to{" "}
          <InlineMath math="b > 0" />; ponizej zera to{" "}
          <InlineMath math="b < 0" />; jesli w punkcie{" "}
          <InlineMath math="(0,0)" />, to <InlineMath math="b = 0" />.
        </li>
      </ul>
      <p>W tym przypadku:</p>
      <BlockMath math={`a ${sign(data.a)},\\quad b ${sign(data.b)}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer?.a || !userAnswer?.b) return <i>(brak odpowiedzi)</i>;

  return (
    <div style={{ display: "flex", gap: "1.5rem", marginTop: "0.5rem" }}>
      <InlineMath math={`a ${userAnswer.a}`} />
      <InlineMath math={`b ${userAnswer.b}`} />
    </div>
  );
}
